import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../service/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public show: boolean = false;
  public numeroDocumento: number;
  mostrar: boolean = true;
  mostrarLoader: boolean = false;

  constructor(
    public router: Router,
    private authService: LoginService
  ) { }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  onInputChange(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, '');
  }

  resetPassword() {
    if (!this.numeroDocumento) {
      Swal.fire({
        title: 'Campo incompleto',
        text: 'El campo Número de documento es obligatorio',
        icon: "info",
        confirmButtonText: 'Aceptar',
        customClass: {
          confirmButton: 'btn btn-primary btn-pills border-0'
        }
      });
      return;
    }
    this.mostrar = false;
    this.mostrarLoader = true;
    this.authService.resetPassword(this.numeroDocumento).subscribe((resp) => {
      if (resp.isSuccess) {
        this.mostrarLoader = false;
        this.router.navigateByUrl('change-password/' + this.numeroDocumento)
      } else {
        this.mostrar = true;
      }
    })
  }
}